module.exports = __webpack_public_path__ + "img/69600.63e108e0.jpg";